import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { ApiTokenService } from "./shared/services/api/token/api-token.service";
import { Subject } from "rxjs";
import {
	MSAL_GUARD_CONFIG,
	MsalBroadcastService,
	MsalGuardConfiguration,
	MsalService,
} from "@azure/msal-angular";
import { Location } from "@angular/common";
import { BrowserUtils, InteractionStatus } from "@azure/msal-browser";
import { filter, takeUntil } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
	title = "customan-angular11";

	isIframe = false;
	loginDisplay = false;
	private readonly _destroying$ = new Subject<void>();

	constructor(
		private tokenService: ApiTokenService,
		private authService: MsalService,
		private msalBroadcastService: MsalBroadcastService,
		private location: Location
	) {
		// Esperar a que se resuelva la promesa de getConexionIACPOS y luego cargar la aplicación
		this.tokenService.getConexionIACPOS();
	}

	ngOnInit(): void {
		const currentPath = this.location.path();
		// Dont perform nav if in iframe or popup, other than for front-channel logout

		if (environment["HAS_LOGIN_MICROSOFT"]) {
			this.isIframe =
				BrowserUtils.isInIframe() &&
				!window.opener &&
				currentPath.indexOf("logout") < 0; // Remove this line to use Angular Universal
			this.setLoginDisplay();

			this.msalBroadcastService.inProgress$
				.pipe(
					filter(
						(status: InteractionStatus) => status === InteractionStatus.None
					),
					takeUntil(this._destroying$)
				)
				.subscribe(() => {
					console.log({
						message: "InteractionStatus changed to None",
						activeAccount: this.authService.instance.getActiveAccount(),
						accounts: this.authService.instance.getAllAccounts()
					});
					this.setLoginDisplay();
					this.checkAndSetActiveAccount();
				});
		}
	}

	setLoginDisplay() {
		this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
	}

	checkAndSetActiveAccount() {
		/**
		 * If no active account set but there are accounts signed in, sets first account to active account
		 * To use active account set here, subscribe to inProgress$ first in your component
		 * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
		 */
		let activeAccount = this.authService.instance.getActiveAccount();

		if (
			!activeAccount &&
			this.authService.instance.getAllAccounts().length > 0
		) {
			let accounts = this.authService.instance.getAllAccounts();
			this.authService.instance.setActiveAccount(accounts[0]);

      console.log({
        message: "No active account set, setting first account as active",
        activeAccount: this.authService.instance.getActiveAccount(),
        accounts: this.authService.instance.getAllAccounts()
      })
		}
	}

	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}
}
